import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../error/error-handling/product-management-error';

export const OrganizationActions = createActionGroup({
  source: 'Organization',
  events: {
    'Load Organization Name': emptyProps(),
    'Load Organization Name Success': props<{organizationName: string}>(),
    'Load Organization Name Failure': props<{error: ProductManagementErrorInterface}>(),
  },
});
